import TakeAPhoto from "./TakeAPhoto";
import {getGUID} from "../assets/constants";

class TakeAPhotoToQueue extends TakeAPhoto{
    setCurrentPhoto() {
        const filename = getGUID()+'.jpg'
        const self = this
        const destination =  this.props.destination ?? 'monitoring'

        // Применяем поворот к изображению перед сохранением
        this.applyRotationToImage(this.state.uri, this.state.rotationAngle).then((rotatedDataUri) => {
            if (!rotatedDataUri) {
                this.props.openErrorNoty && this.props.openErrorNoty('Не удалось обработать фото. Попробуйте сделать снимок ещё раз.')
                return
            }
            this.setActiveModal(null)
            this.props.hidePhotos()
            window.postMessage({type: 'addPhotoToQueue', uri: rotatedDataUri, filename, destination})
            setTimeout(() => {
                window.postMessage({
                    type: this.props.eventName ?? "setMonitoringImage",
                    data: {
                        numImage: this.props.numImage ?? null,
                        image: self.props.url +'/uploads/'+ destination+'/'+filename,
                        thumb: self.props.url + '/image.php?w=300&src=/uploads/' + destination+'/'+filename,
                        angle_id: self.getSelectedAngleId()
                    }
                })
                self.setState({uri: null, progress: 0, uploadPending: false, rotationAngle: 0})
            }, 700)
        });
    }

    // Переопределяем uploadAllPhotos для работы с очередью
    uploadAllPhotos = async () => {
        const { selectedFiles } = this.state;
        if (selectedFiles.length === 0) return;

        this.setState({ uploadPending: true, progress: 0, currentUploadIndex: 0, uploadedCount: 0 });

        const destination = this.props.destination ?? 'monitoring';
        const uploadedImages = []; // Массив для сбора всех изображений
        const angleId = this.getSelectedAngleId();

        try {
            for (let i = 0; i < selectedFiles.length; i++) {
                this.setState({ currentUploadIndex: i });

                const fileData = selectedFiles[i];
                if (!fileData.dataUri) {
                    console.warn('Пропускаем файл без данных изображения:', fileData);
                    continue;
                }
                const filename = getGUID() + '.jpg';
                
                // Добавляем фото в очередь
                window.postMessage({
                    type: 'addPhotoToQueue', 
                    uri: fileData.dataUri, 
                    filename, 
                    destination
                });
                
                // Сохраняем информацию о изображении для финального события
                uploadedImages.push({
                    image: this.props.url + '/uploads/' + destination + '/' + filename,
                    thumb: this.props.url + '/image.php?w=300&src=/uploads/' + destination + '/' + filename,
                    angle_id: angleId
                });
                
                this.setState(prevState => ({ uploadedCount: prevState.uploadedCount + 1 }));
                
                // Обновляем прогресс
                const progress = Math.round(((i + 1) / selectedFiles.length) * 100);
                this.setState({ progress });
                
                // Небольшая задержка между добавлениями в очередь
                await new Promise(resolve => setTimeout(resolve, 100));
            }

            // Все файлы добавлены в очередь - отправляем событие множественной загрузки
            const multipleEventName = this.props.multipleEventName || (this.props.eventName + '_multiple');
            
            setTimeout(() => {
                window.postMessage({
                    type: multipleEventName,
                    data: {
                        numImage: this.props.numImage ?? null,
                        images: uploadedImages // Массив всех изображений
                    }
                });
            }, 700);

            this.setActiveModal(null);
            this.props.hidePhotos();
            
            setTimeout(() => {
                this.setState({
                    selectedFiles: [],
                    isMultipleMode: false,
                    uploadPending: false,
                    progress: 0,
                    currentUploadIndex: 0,
                    uploadedCount: 0
                });
            }, 1000);

        } catch (error) {
            console.error('Ошибка добавления фото в очередь:', error);
            this.props.openErrorNoty('Ошибка обработки одного или нескольких изображений!');
            this.setState({ uploadPending: false });
        }
    };
}
export default TakeAPhotoToQueue
